import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { DataxRoleService } from '@services/datax-roles.service';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface RoleOption {
  label: string;
  value: string | null;
}

@Component({
  selector: 'scaffold-select-datax-role',
  templateUrl: './select-datax-role.component.html',
  styleUrls: [
    '../../rendered.component.scss',
    './select-datax-role.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectDataxRoleComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() change = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  public roleOptions: RoleOption[] = [];
  public selectedRole: string | null = null;
  public loading = true;

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private dataxRoleService: DataxRoleService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit(): void {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.cdr.detectChanges();
      });

    this.loadRoles();
    this.update();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  loadRoles(): void {
    this.loading = true;
    this.dataxRoleService.getRoles$().subscribe({
      next: response => {
        this.roleOptions = [
          { label: 'None', value: null },

          ...response.data.results.map(role => ({
            label: role.role_name,
            value: role.role_name,
          })),
        ];
        this.loading = false;
        this.update();
      },
      error: error => {
        console.error('Error loading roles:', error);
        this.roleOptions = [{ label: 'None', value: null }];
        this.loading = false;
        this.update();
      },
    });
  }

  onRoleChange(value: string | null): void {
    this.selectedRole = value;
    this.change.emit({ value: this.selectedRole });
  }

  update() {
    this.selectedRole = this.value;
    this.cdr.detectChanges();
  }
}
